import React from "react";
import { FaMagnifyingGlass, FaArrowsRotate, FaChartColumn, FaHeadset, FaArrowRight } from "react-icons/fa6";
import { SiWordpress, SiShopify, SiWoocommerce, SiPhp, SiLaravel, SiReact, SiNextdotjs, SiMagento } from "react-icons/si";
import { Container, H2_SIZE, H3_SIZE } from "../home/ui";

const steps = [
  { icon: FaMagnifyingGlass, title: "Monitor", text: "We continuously monitor your website for issues.", tone: "bg-[#E3EDFF] text-[#2563EB]" },
  { icon: FaArrowsRotate, title: "Update", text: "Regular updates to keep everything secure.", tone: "bg-[#DFF7EC] text-[#10B981]" },
  { icon: FaChartColumn, title: "Optimize", text: "Improve performance and fix issues.", tone: "bg-[#E3EDFF] text-[#2563EB]" },
  { icon: FaHeadset, title: "Support", text: "Get ongoing support whenever you need it.", tone: "bg-[#FFE4E6] text-[#EF4444]" },
];

const techs = [
  { icon: SiWordpress, label: "WordPress", tone: "text-[#21759B]" },
  { icon: SiShopify, label: "Shopify", tone: "text-[#95BF47]" },
  { icon: SiWoocommerce, label: "WooCommerce", tone: "text-[#96588A]" },
  { icon: SiPhp, label: "PHP", tone: "text-[#777BB4]" },
  { icon: SiLaravel, label: "Laravel", tone: "text-[#FF2D20]" },
  { icon: SiReact, label: "React", tone: "text-[#61DAFB]" },
  { icon: SiNextdotjs, label: "Next.js", tone: "text-black" },
  { icon: SiMagento, label: "Magento", tone: "text-[#EE672F]" },
];

const MaintProcessTech = () => (
  <section className="bg-white py-[48px] lg:py-[68px]">
    <Container className="max-w-[1200px]">
      <div className="text-center">
        <h2 className={`font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>
          Our <span className="text-[#1E6BFF]">Maintenance Process</span>
        </h2>
        <p className="mx-auto mt-[12px] max-w-[560px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
          A simple and effective process to keep your website healthy.
        </p>
      </div>

      <div className="m-swipe mt-[40px] grid gap-[32px] sm:grid-cols-2 lg:grid-cols-4 lg:gap-[24px]">
        {steps.map((s, i) => (
          <div key={s.title} className="relative flex flex-col items-center text-center">
            <span className={`inline-flex h-[84px] w-[84px] items-center justify-center rounded-full text-[32px] ${s.tone}`}>
              <s.icon />
            </span>
            {i < steps.length - 1 && (
              <FaArrowRight className="absolute left-[calc(100%-12px)] top-[34px] hidden -translate-x-1/2 text-[18px] text-slate-400 lg:block" />
            )}
            <h3 className={`mt-[18px] font-bold text-[#0B1A4A] ${H3_SIZE}`}>{s.title}</h3>
            <p className="mt-[8px] max-w-[200px] text-[14px] leading-[1.55] text-slate-600">{s.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-[64px] text-center">
        <h2 className={`font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>
          Technologies We Support
        </h2>
        <p className="mx-auto mt-[10px] max-w-[560px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
          We work with all major platforms and technologies.
        </p>
      </div>

      <div className="mt-[28px] grid grid-cols-4 gap-[12px] sm:gap-[16px] lg:grid-cols-8">
        {techs.map((t) => (
          <div
            key={t.label}
            title={t.label}
            className="flex aspect-[5/3] items-center justify-center rounded-[14px] bg-[#F6F8FC] text-[30px] transition hover:-translate-y-1 hover:bg-white hover:shadow-[0_14px_30px_-20px_rgba(40,60,140,0.4)] sm:text-[40px]"
          >
            <t.icon className={t.tone} aria-label={t.label} />
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default MaintProcessTech;
